import { inject, Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { AuthService } from '../../services/auth.service'
import { LoggedIn, LogIn, Logout } from './auth.actions'
import { finalize, tap } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { jwtDecode } from 'jwt-decode'

export interface AuthStateModel {
  token: string | null
  isLoading: boolean
}
@State({
  name: 'auth',
  defaults: {
    token: null,
    isLoading: false,
  },
})
@Injectable()
export class AuthState {
  authService = inject(AuthService)
  httpClient = inject(HttpClient)

  @Selector()
  static getToken(state: AuthStateModel): string | null {
    return state.token
  }

  @Selector()
  static getIsAuthenticated(state: AuthStateModel): boolean {
    //TODO: verification de la date d'expiration du token
    if (!state.token) return false

    const decodedToken = jwtDecode(state.token)
    const currentTimestamp = Date.now() / 1000
    if (decodedToken.exp && decodedToken.exp < currentTimestamp) return false

    return true
  }
  @Selector()
  static getIsLoading(state: AuthStateModel): boolean {
    return !!state.isLoading
  }

  @Selector()
  static getRoles(state: AuthStateModel): string[] {
    if (!state.token) return []
    const decoded = jwtDecode<{ roles?: string[] }>(state.token)
    return decoded.roles ?? []
  }
  @Action(LogIn)
  logIn(ctx: StateContext<AuthStateModel>, action: LogIn) {
    ctx.patchState({ isLoading: true })
    return this.authService.login(action.payload).pipe(
      tap((response) => {
        ctx.dispatch(new LoggedIn(response))
      }),
      finalize(() => {
        ctx.patchState({ isLoading: false })
      })
    )
  }

  @Action(LoggedIn)
  loggedIn(ctx: StateContext<AuthStateModel>, action: LoggedIn) {
    ctx.patchState({ token: action.response.accessToken })
  }

  @Action(Logout)
  logout(ctx: StateContext<AuthStateModel>) {
    ctx.patchState({ token: null })
  }
}
